import { useQuery } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import type { NotificationResponse } from "~types/notification.ts";

export const useGetNotifications = () => {
  const request = useApi();

  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => request<NotificationResponse>(`notifications`).then((response: NotificationResponse) => response?.data || []),
    refetchInterval: 15000,
  });
};
